import { Component } from '@angular/core';

@Component({
  selector: 'base-customer-dashboard-unpublished-inquiries-list-headline',
  templateUrl: './dashboard-unpublished-inquiries-list-headline.component.html',
})
export class BaseCustomerDashboardUnpublishedInquiriesListHeadlineComponent {}
